/* eslint-disable no-useless-escape */
import { mapGetters } from 'vuex';

function isValidUrl(input) {
  const regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
  return regex.test(input);
}

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imageLoadError: false,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    showSubtitle() {
      return this.data && this.data.origin && this.data.origin.title;
    },
    shouldShowImage() {
      return !this.imageLoadError;
    },
    containerModifier() {
      return {
        'news-feed-item--no-image': this.imageLoadError,
      };
    },
    contentModifier() {
      return {
        'small-8': !this.imageLoadError,
        'small-12': this.imageLoadError,
      };
    },
    url() {
      return this.data.originId;
    },
    target() {
      return isValidUrl(this.url) && this.isLayoutDesktop ? '_blank' : '_self';
    },
  },
  methods: {
    getItemImage(item) {
      if (item.visual && item.visual.url) {
        return item.visual.url;
      }

      this.imageLoadError = true;
      return null;
    },
    onImageLoadError() {
      this.imageLoadError = true;
    },
  },
};
